import { lazy, Suspense } from 'react';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { WhatsAppButton } from '@/components/WhatsAppButton';
import { SEOHead, organizationSchema, websiteSchema, productListSchema } from '@/components/SEOHead';
import { products } from '@/components/solutions/productsData';
import { LazySection } from '@/components/LazySection';

// Lazy-load all below-fold sections
const Marquee = lazy(() => import('@/components/Marquee').then(m => ({ default: m.Marquee })));
const QuemSomos = lazy(() => import('@/components/QuemSomos').then(m => ({ default: m.QuemSomos })));
const BannersSection = lazy(() => import('@/components/BannersSection').then(m => ({ default: m.BannersSection })));
const ContactSection = lazy(() => import('@/components/ContactSection').then(m => ({ default: m.ContactSection })));
const SolutionsSection = lazy(() => import('@/components/SolutionsSection').then(m => ({ default: m.SolutionsSection })));
const SustainabilitySection = lazy(() => import('@/components/SustainabilitySection').then(m => ({ default: m.SustainabilitySection })));

const Footer = lazy(() => import('@/components/Footer').then(m => ({ default: m.Footer })));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Tubos Canaã — Fabricante de Tubos de PVC Reciclado"
        description="Tubos de PVC fabricados com material 100% reciclado em Itaúna (MG) para construção, irrigação e saneamento. 24 anos de história."
        path="/"
        jsonLd={[organizationSchema, websiteSchema, productListSchema(products)]}
      />
      <Navbar />
      <main>
        <Hero />

        {/* Near-fold: loads soon after hero */}
        <LazySection rootMargin="200px" minHeight="60px">
          <Suspense fallback={null}>
            <Marquee />
          </Suspense>
        </LazySection>

        {/* Quem Somos */}
        <LazySection id="quem-somos" rootMargin="400px" minHeight="600px">
          <Suspense fallback={null}>
            <QuemSomos />
          </Suspense>
        </LazySection>

        {/* Banners após Quem Somos */}
        <LazySection rootMargin="300px" minHeight="200px">
          <Suspense fallback={null}>
            <BannersSection />
          </Suspense>
        </LazySection>

        <LazySection id="segmentos" minHeight="600px">
          <Suspense fallback={null}>
            <SolutionsSection />
          </Suspense>
        </LazySection>

        <LazySection id="sustentabilidade" minHeight="500px">
          <Suspense fallback={null}>
            <SustainabilitySection />
          </Suspense>
        </LazySection>

        <LazySection id="contato" minHeight="500px">
          <Suspense fallback={null}>
            <ContactSection />
          </Suspense>
        </LazySection>

      </main>

      <LazySection rootMargin="200px" minHeight="200px">
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </LazySection>

      <WhatsAppButton />
    </div>
  );
};

export default Index;
